import script from "./BrandCharacteristicValueCodesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandCharacteristicValueCodesDialog.vue?vue&type=script&setup=true&lang=js"

import "./BrandCharacteristicValueCodesDialog.vue?vue&type=style&index=0&id=6c72c2a4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c72c2a4"]])

export default __exports__